import React from "react";
import { Mail, Phone, MapPin, Clock } from "lucide-react";
import { bookingConfig } from "../../../../data/booking/bookingConfig";
import "./ContactInfo.css";

const ContactInfo = () => {
  const contactMethods = [
    {
      icon: <Mail size={24} />,
      label: "Email Us",
      value: bookingConfig.contactEmail,
      link: `mailto:${bookingConfig.contactEmail}`,
    },
    {
      icon: <Phone size={24} />,
      label: "Call Us",
      value: bookingConfig.contactPhone,
      link: `tel:${bookingConfig.contactPhone}`,
    },
    {
      icon: <MapPin size={24} />,
      label: "Location",
      value: "London, United Kingdom",
      link: null,
    },
    {
      icon: <Clock size={24} />,
      label: "Business Hours",
      value: "Mon-Fri: 9:00 AM - 10:00 PM (UK Time)",
      link: null,
    },
  ];

  return (
    <section className="contact-info">
      <div className="contact-info__container">
        <div className="contact-info__header">
          <h2 className="contact-info__title">Other Ways to Reach Us</h2>
          <p className="contact-info__subtitle">
            Prefer a different method? We're here to help.
          </p>
        </div>

        <div className="contact-info__grid">
          {contactMethods.map((method, index) => (
            <div key={index} className="contact-info__card">
              <div className="contact-info__icon">{method.icon}</div>
              <div className="contact-info__label">{method.label}</div>
              {method.link ? (
                <a
                  href={method.link}
                  className="contact-info__value contact-info__value--link"
                >
                  {method.value}
                </a>
              ) : (
                <div className="contact-info__value">{method.value}</div>
              )}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default ContactInfo;
